export const games = ['G1', 'G2', 'G3', 'G4', 'G5'] as const;
